// src/pages/wartungsprotokoll/WartungsprotokollSeite9.jsx

import React, { useState } from "react";
import { Box } from "@chakra-ui/react";
import { Button } from "@chakra-ui/react";

export default function WartungsprotokollSeite9({ form, setForm }) {

  
    const [showZusatz1, setShowZusatz1] = useState(false);
   

  if (
    !form ||
    !form.pruefungWRZentral ||
    !form.zusatzWRZentral
  ) return null;


  const updateRow = (section, index, field) => {
    setForm(prev => {
      const updated = [...prev[section]];
      updated[index][field] = !updated[index][field];
      return { ...prev, [section]: updated };
    });
  };

  const updateZusatz = (table, index, field, value) => {
    setForm(prev => {
      const updated = [...prev[table]];
      updated[index][field] = value;
      return { ...prev, [table]: updated };
    });
  };

  return (
      
    <div className="p-6 text-sm">
      <Box p={8} bg="white" borderRadius="xl" boxShadow="md" mt={3} mb={3}>

      {/* ================= SECTION 13 ======================= */}

     <h2 style={{ fontWeight: "bold" }}>
        13 Zentralwechselrichter (sofern installiert)
      </h2>

      <p className="text-xs mb-2">
        Die folgenden Überprüfungen wurden durchgeführt:<br />
        Die weiteren Wartungshinweise gem. Herstellervorgaben sind ebenfalls zu beachten und auszuführen!
        Wartungsmappe: B6 – Unterlagen WR, Wartungshinweise
      </p>

      <table className="w-full mb-6 text-xs" style={{ borderCollapse: "collapse" }}>
         <thead>
          <tr className="border-b font-semibold text-center">
            <th className="p-2 w-2/3 text-left"></th>
            <th className="p-2 min-w-[90px]">ja</th>
            <th className="p-2 min-w-[90px]">nein</th>
            <th className="p-2 min-w-[90px]">nicht zutreffend</th>
          </tr>
        </thead>
        <tbody>
          {[
            "13.1 Die WR-Gebäude sind frei und zugänglich",
            "13.2 Die WR-Gebäude befinden sich in gutem Zustand",
            "13.3 Der Innenraum der WR ist in Ordnung (Verschmutzung, Feuchtigkeit usw.)",
            "13.4 Die Türen der WR in Ordnung (Dichtungen, Scharniere, Verriegelungen)",
            "13.5 Heizung vorhanden und betriebsbereit",
            "13.6 Hygrostat in Ordnung",
            "13.7 Reinigung Luftkanal, Insektenschutzgitter und Filter durchgeführt",
            "13.8 Lüfter in Ordnung",
            "13.9 Reinigung Lüfter durchgeführt",
            "13.10 Stationsbeleuchtung und Steckdosen in Ordnung",
            "13.11 Die Kabelverschraubungen sind fest und dicht",
            "13.12 Sammelschienen und Isolatoren in Ordnung (bei Bedarf gereinigt)",
            "13.13 Klemmverbindung der Leistungseverkabelung in Ordnung",
            "13.14 Steck-/Klemmverbindung der Strangverkabelung in Ordnung",
            "13.15 Erdverbindungen in Ordnung",
            "13.16 Sicherungen in Ordnung",
            "13.17 Isolierungen in Ordnung",
            "13.18 Berührungsschutz vorhanden und in Ordnung",
            "13.19 Überspannungsableiter in Ordnung",
            "13.20 Die Schalteinheiten sind funktionsfähig und in Ordnung",
            "13.21 Alle WR sind funktionsfähig und speisen ein, ohne Fehlermeldungen",
            "13.22 Versorgungsspannung und USV in Ordnung",
            "13.23 Weitere Wartungsmaßnahmen laut Angaben WR-Hersteller durchgeführt"
          ].map((text, idx) => (
            <tr key={idx}>
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "70%" }}>
                {text}
              </td>

              {/* Ja */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
              
                <input
                  type="checkbox"
                  checked={form.pruefungWRZentral?.[idx]?.ja || false}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.pruefungWRZentral || [])];
                      list[idx] = { ja: true, nein: false, nz: false };
                      return { ...f, pruefungWRZentral: list };
                    })
                  }
                />
              </td>

              {/* Nein */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
                
                <input
                  type="checkbox"
                  checked={form.pruefungWRZentral?.[idx]?.nein || false}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.pruefungWRZentral || [])];
                      list[idx] = { ja: false, nein: true, nz: false };
                      return { ...f, pruefungWRZentral: list };
                    })
                  }
                />
              </td>

              {/* n.z. */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
                
                <input
                  type="checkbox"
                  checked={form.pruefungWRZentral?.[idx]?.nz || false}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.pruefungWRZentral || [])];
                      list[idx] = { ja: false, nein: false, nz: true };
                      return { ...f, pruefungWRZentral: list };
                    })
                  }
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      
       <Box mb={3} mt={4}>
            <Button
               onClick={() => setShowZusatz1(!showZusatz1)}
               colorScheme="blue"
              borderRadius="lg"
             >
             {showZusatz1 ? "Zusatz-Tabelle minimieren" : "Zusatz-Tabelle anzeigen"}
              </Button>  
      </Box>

      {/* ============ ZUSATZTABLE ================= */}

     {showZusatz1 && (
        <>

      <h3 className="font-semibold mb-2 mt-4">Zusatz-Tabelle</h3>

      <table className="w-full mb-6 text-xs" style={{ borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "15%" }}>Zu Punkt</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "45%" }}>
              Bemerkungen / Mängel
            </th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "15%" }}>
              Standort Mangel
            </th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>Plan</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "10%" }}>Bild-Nr.</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>Beh.</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>n. Beh.</th>
          </tr>
        </thead>

        <tbody>
          {form.zusatzWRZentral.map((row, idx) => (
            <tr key={idx}>
              {["zupunkt", "bemerkung", "standort"].map(field => (
                <td key={field} style={{ border: "1px solid #ccc", padding: "3px" }}>
                  <input
                    type="text"
                    value={row[field]}
                    onChange={e =>
                      updateZusatz("zusatzWRZentral", idx, field, e.target.value)
                    }
                    style={{
                      width: "100%",
                      border: "none",
                      backgroundColor: "#f7f7fb",
                      height: "18px"
                    }}
                  />
                </td>
              ))}

              <td style={{ border: "1px solid #ccc", textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={row.plan}
                  onChange={() => updateZusatz("zusatzWRZentral", idx, "plan", !row.plan)}
                />
              </td>

              <td style={{ border: "1px solid #ccc", padding: "3px" }}>
                <input
                  type="text"
                  value={row.bildnr}
                  onChange={e => updateZusatz("zusatzWRZentral", idx, "bildnr", e.target.value)}
                  style={{
                    width: "100%",
                    border: "none",
                    backgroundColor: "#f7f7fb",
                    height: "18px"
                  }}
                />
              </td>

              {["beh", "nbeh"].map(field => (
                <td key={field} style={{ border: "1px solid #ccc", textAlign: "center" }}>
                  <input
                    type="checkbox"
                    checked={row[field]}
                    onChange={() => updateZusatz("zusatzWRZentral", idx, field, !row[field])}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
       </>
       )}
      </Box>
    </div>
  );
}